const SUPPORT_EMAIL = 'support@boundly.com';
const TERMS_OF_USE_LINK = 'https://boundly.com/terms-of-use-boundly-non-us.html';
const PRIVACY_POLICY_LINK = 'https://boundly.com/privacy-policy-boundly-non-us.html';
const COOKIE_POLICY_LINK = 'https://boundly.com/cookie-policy-boundly.html';

export {
    SUPPORT_EMAIL,
    TERMS_OF_USE_LINK,
    PRIVACY_POLICY_LINK,
    COOKIE_POLICY_LINK
};
